module.exports = __webpack_public_path__ + "static/media/rightArrow.5e5b72cc.svg";